<template>
  <!-- 供电监控数字面板 -->
  <div>
    <div class="fr jc ac ov mb-10">
      <div class="fc " style="width: 20%;">
        <div class="pane-data-value">{{ ratedTotalLoad }}</div>
        <div class="pane-data-label">额定总负载</div>
      </div>

      <div class="fc" style="width: 30%;">
        <div class="pane-data-value">{{ realTotalLoad }}</div>
        <div class="pane-data-label">实时总负载</div>
      </div>

      <div class="fc" style="width: 20%;">
        <div class="pane-data-value">{{ itTotalLoad }}</div>
        <div class="pane-data-label">额定IT负载</div>
      </div>

      <div class="fc" style="width: 30%;">
        <div class="pane-data-value">{{ itRealTotalLoad }}</div>
        <div class="pane-data-label">实时IT负载</div>
      </div>
    </div>

    <div class="fr ac ov mb-5">
      <div class="mr-10" style="width: 65px; text-align: center;">
        UPS:&nbsp;
      </div>
      <div class="mr-10" style="width: 70px; text-align: center;">
        <div class="pane-data-label mr-10" style="font-size: 12px;line-height: 26px; text-align: left;">输入电压:</div>
        <div class="pane-data-label mr-10" style="font-size: 12px;line-height: 26px; text-align: left;">输出电压:</div>
      </div>
      <div class="jc as ov" style="width: 220px;">
        <div class="pane-data-value">{{ inputVoltage }}</div>
        <div class="pane-data-value">{{ outputVoltage }}</div>
      </div>
    </div>

    <div class="fr jc ac ov mt-5 mb-10" style="height: 35px;">
      <div class="fr pane-data-block mt-5 mr-10" style="width: 32%;">
        <div class="pane-data-label mr-5" style="font-size: 12px;line-height: 26px;">电池电压:</div>
        <div class="pane-data-value">{{ batteryVoltage }}</div>
      </div>
      <div class="fr pane-data-block mt-5 mr-5" style="width: 28%;">
        <div class="pane-data-label mr-5" style="font-size: 12px;line-height: 26px;">电池容量:</div>
        <div class="pane-data-value">{{ bateryCapacity }}</div>
      </div>
      <div class="fr vb pane-data-block mt-5" style="width: 33%;align-items: baseline;">
        <div class="pane-data-label mr-5" style="font-size: 12px;line-height: 26px;">剩余时间:</div>
        <div class="pane-data-value">{{ batteryTime }}</div>
        <div class="pane-data-value" style="font-size: 8px; line-height: 12px; color: #FFF;">分钟</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'pane-energy',
  components: {},
  props: {
    chartData: {
      type: Object,
      required: true,
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler () {
        this.update()
      }
    }
  },
  data() {
    return {
      ratedTotalLoad: '',
      realTotalLoad: '',
      itTotalLoad: '',
      itRealTotalLoad: '',
      inputVoltage: '',
      outputVoltage: '',
      batteryVoltage: '',
      bateryCapacity: '',
      batteryTime: '',
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.update()
    })
  },
  methods: {
    update () {
      if (!this.chartData) return
      this.ratedTotalLoad = this.chartData.rated_totalLoad
      this.realTotalLoad = this.chartData.real_totalLoad
      this.itTotalLoad = this.chartData.it_totalLoad
      this.itRealTotalLoad = this.chartData.it_real_totalLoad
      this.inputVoltage = this.chartData.input_voltage
      this.outputVoltage = this.chartData.output_voltage
      this.batteryVoltage = this.chartData.battery_voltage
      this.bateryCapacity = this.chartData.battery_capacity
      this.batteryTime = this.chartData.battery_time
    },
  }
}
</script>

<style lang="css" scoped>

.pane-overall {
  width: 100%;
  height: 60px;
  background: rgba(0, 145, 133, 0.12);
}

.pane-data-block {
  height: 100%;
}

.pane-data-value {
  line-height: 26px;
  font-size: 14px;
  font-family: Consolas, serif;
  color: #35FFF6;
  text-align: left;
  font-family: aldrich, serif;
}

.pane-data-label {
  line-height: 16px;
  font-size: 10px;
  color: #FFF;
}

</style>
